import { FC } from "react";
import { NavDocsIcon } from "@/components/Icons/NavDocsIcon";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/utils/analytics";
import { AnalyticsEventType } from "@/constants/analytics";
import { useDocsLink } from "./useDocsLink";

export const HeaderDocsButton: FC = () => {
  const { docsLink, isDocsMappingEnabled, pathname } = useDocsLink();

  return (
    <Button className="max-lg:hidden gap-2" size="xs" variant="outline" asChild>
      <a
        href={docsLink}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          if (!isDocsMappingEnabled) {
            return;
          }

          trackEvent("DOCS_LINK_CLICKED" as AnalyticsEventType, { pathname });
        }}
      >
        <NavDocsIcon className="size-[20px] shrink-0" />
        Docs
      </a>
    </Button>
  );
};
